module.exports = __webpack_public_path__ + "static/nyt-02a10b3e41c694c267ac768092f8eb17.svg";